module.exports = __webpack_public_path__ + "static/media/keyboard_arrow_up.d470b964.svg";